import qrcode from 'qrcode'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('qrcode', qrcode)
})
